import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import * as moment from "moment";
import 'rxjs/add/operator/map';

@Injectable()
export class OrderstatusService {

  constructor(private http:HttpClient) {
   }

   getAll(){
     let url = GLOBAL.url+`order_status`;
     return this.http.get(url).map(res=>{
       return res;
     })
   }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/orderstatus.service.ts